import * as E from "fp-ts/lib/Either";
import * as O from "fp-ts/lib/Option";

import type { ReactChild } from "@scripts/react/syntax/react";

export type LabelOrAriaLabel = E.Either<string, string>;
export type ReactChildOrAriaLabel = E.Either<ReactChild, string>;

export const toLabelString: (label: LabelOrAriaLabel) => string = E.toUnion;
export const getLabel: (label: LabelOrAriaLabel) => O.Option<string> = O.getLeft;
